<mat-form-field class="form-item">
  <mat-label>Pump end</mat-label>
  <input type="text" placeholder="Search pump end" matInput [formControl]="pumpendControl"
    [matAutocomplete]="autoController" (focus)="onFocus()" (blur)="updatePumpend($event.target.value)"
    (input)="pumpendChanges.next($event.target.value)" />
  <mat-autocomplete #autoController="matAutocomplete" (optionSelected)="setPumpendChangeAction($event)">
    @for (pumpend of pumpendSuggestions | async; track pumpend; let i = $index) {
      <mat-option [value]="pumpend">
        {{ pumpend }}
        @if (i !== 0) {
          <button class="navigateBtn" (click)="navigateTo(pumpend)" mat-stroked-button>Go to</button>
        }
      </mat-option>
    }
  </mat-autocomplete>
  @if (pumpendControl.hasError('required')) {
    <mat-error>
      Pump end is Required
    </mat-error>
  }
  @if (pumpendControl.hasError('noOption')) {
    <mat-error>
      Pump end not Found
    </mat-error>
  }
</mat-form-field>